module.exports = __webpack_public_path__ + "static/media/jhu_lyme_tracker.9d29d73f.png";